<template>
  <div class="admin-section-header">
    <b-icon :icon="icon" size="is-medium"></b-icon>
    <h2 class="title is-2">{{ $t(title) }}</h2>
  </div>
</template>

<script>
export default {
  name: 'AdminSectionHeader',
  props: {
    icon: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .admin-section-header {
    display: flex;
    margin-bottom: 2em;
  }
  .icon {
    margin: auto;
    margin-left: 0;
    margin-right: 1em;
  }
</style>
